"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Mail, Phone, MapPin, Clock } from "lucide-react";
export default function ContactInformation() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const contactDetails = [{
    icon: Phone,
    label: "Phone",
    value: "323-492-6292",
    href: "tel:323-492-6292"
  }, {
    icon: Mail,
    label: "Email",
    value: "phoenixenerprises@gmail.com",
    href: "mailto:phoenixenerprises@gmail.com"
  }, {
    icon: MapPin,
    label: "Location",
    value: "Los Angeles, CA, USA",
    href: null
  }, {
    icon: Clock,
    label: "Availability",
    value: "24/7 Availability",
    href: null
  }];
  return <section id="contact-information" className="dark bg-background text-foreground relative min-h-screen overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/los_angeles_skyline_dusk_blurred.png)] opacity-30" aria-hidden="true" />

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={leftRef} className={`flex items-center justify-center p-6 md:p-12 transition-all duration-[var(--duration-slow)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <div className="glass-effect max-w-md w-full p-6 sm:p-10 md:p-14 rounded-2xl shadow-strong">
            <h2 className="font-display text-4xl md:text-5xl font-bold mb-4 color-primary">
              Get In Touch
            </h2>
            <p className="text-muted-foreground mb-8">
              Contact us for luxury transportation services in Los Angeles
            </p>

            <div className="space-y-8">
              {contactDetails.map((detail, i) => {
              const Icon = detail.icon;
              return <div key={i} data-index={i} className={`flex items-start gap-4 transition-all duration-[var(--duration-medium)] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
                transitionDelay: `${i * 100}ms`
              }}>
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary/10 flex items-center justify-center">
                      <Icon className="w-5 h-5 color-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-bold text-muted-foreground uppercase tracking-widest mb-1">
                        {detail.label}
                      </p>
                      {detail.href ? <Button variant="link" onClick={() => window.location.href = detail.href} className="text-foreground font-medium hover:color-primary transition-colors duration-[var(--duration-fast)] group h-auto p-0 relative">
                          <span className="relative">
                            {detail.value}
                            <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-[var(--duration-medium)]" />
                          </span>
                        </Button> : <p className="text-foreground font-medium">{detail.value}</p>}
                    </div>
                  </div>;
            })}
            </div>

            <div className="mt-10 pt-8 border-t border-white/10">
              <Button className="btn-primary w-full" onClick={() => window.location.href = "tel:323-492-6292"}>
                <Phone className="w-4 h-4" />
                Call Now
              </Button>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`flex items-center justify-center p-6 md:p-12 transition-all duration-[var(--duration-slow)] ${rightVisible ? "opacity-100 scale-100" : "opacity-0 scale-110"}`}>
          <div className="glass-effect w-full h-full min-h-[400px] lg:min-h-[600px] overflow-hidden rounded-2xl shadow-strong">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d423286.27404345275!2d-118.69192993701652!3d34.02016130653294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s" width="100%" height="100%" style={{
            border: 0,
            filter: "grayscale(100%) contrast(1.2)"
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Los Angeles Location Map" className="w-full h-full" />
          </div>
        </div>
      </div>
    </section>;
}